import React, { useState, useEffect } from "react";
import axios from "axios";
import CareersHero from "./Components/CareersHero/CareersHero";
import JobDetails from "./Components/JobDetails/JobDetails";
import styles from "./Components/JobDetails/JobDetails.module.css";
import LifeAt from "../Home/components/LifeAt/LifeAt";
import PDFResumeExtractor from "../../utils/PdfExtractor/PdfExtractor";

const Careers = () => {
  const [jobs, setJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch jobs from API
  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axios.get(
          "https://spacelabs-backend.vercel.app/api/jobs"
        );
        setJobs(response.data);
      } catch (err) {
        setError("Failed to load jobs.");
      } finally {
        setLoading(false);
      }
    };
    const minDelay = 2000;
    const maxDelay = 5000;
    const randomDelay =
      Math.floor(Math.random() * (maxDelay - minDelay + 1)) + minDelay;
    setTimeout(() => {
      fetchJobs();
    }, randomDelay);
  }, []);

  return (
    <div>
      {/* Show loading or error message */}
      {loading ? (
        <div className={styles.loading}>Loading Jobs...</div>
      ) : error ? (
        <p className={styles.error}>{error}</p>
      ) : (
        <CareersHero
          jobs={jobs}
          selectedJob={selectedJob}
          setSelectedJob={setSelectedJob}
        />
      )}

      {/* Show job details when a job is selected */}
      {selectedJob && (
        <div className={styles.jobDetailsSection}>
          <JobDetails job={selectedJob} />
        </div>
      )}

      <LifeAt />
    </div>
  );
};

export default Careers;
